<script setup lang="ts">
defineProps<{
  variant: SingleProductVariant;
}>();
</script>

<template>
  <UiCartAddWidget
    v-if="variant.isPurchasable"
    class="anti-padded"
    :variant="variant"
    dir="horizontal"
  />
  <div v-else class="cta anti-padded">
    <span>Fysiske bøker selges hos forhandler:</span>
    <UButton
      class="rounded-full bg-yellow-30 px-m py-xs text-[--ui-text] no-underline hover:bg-yellow-40"
      :href="`https://www.norli.no/${variant.isbn}`"
      target="_blank"
      trailing-icon="far:external-link"
      :ui="{
        trailingIcon: 'size-3.5',
      }"
    >
      Kjøp boka hos Norli
    </UButton>
  </div>
</template>

<style scoped>
@reference "~/assets/styles/main.css";

.anti-padded {
  --anti-padding: calc((var(--outer-padding) + var(--inner-padding)) * -1);

  @media screen and (max-width: theme("screens.sm")) {
    border-radius: 0 !important;
    margin-inline: var(--anti-padding);
    margin-bottom: var(--anti-padding);
  }
}

div {
  display: flex;
  gap: 0.6rem;
  --padding-inline: var(--spacing-s);
  --padding-block: var(--spacing-m);

  @media screen and (min-width: theme("screens.sm")) {
    --padding-block: theme("spacing.5");
    --padding-inline: theme("spacing.5");
  }

  :deep(.ks-button) {
    color: var(--color-black);
    font-weight: 400;
    flex: 1;

    :deep(.ks-icon) {
      transform: scale(0.75);
    }
  }

  &.cta {
    flex-wrap: wrap;
    /* TODO: Verify that this works */
    background: rgba(white, 0.9);
    justify-content: space-between;
    align-items: center;
    padding-block: var(--padding-block);
    padding-inline: var(--padding-inline);
    border-radius: 0.625rem;
    container-type: inline-size;

    @media screen and (min-width: theme("screens.sm")) {
      /* To align text instead of container */
      margin-left: calc(var(--padding-inline) * -1);
    }

    > * {
      margin: auto;
    }

    @container (width > 33rem) {
      > * {
        margin: initial;
      }

      :deep(.ks-button) {
        flex: initial;
      }
    }

    > span {
      font-size: 1rem;
      font-weight: 600;
    }
  }
}
</style>
